<template>
    <div>
        <h3>Channel List &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="渠道名字" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>
                    <el-col :span="8" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>


        <h5>
            <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
            <!-- <el-button
                type="primary"
                size="medium"
                :disabled="multipleData.length === 0"
                :loading="deleteLoad"
                @click="handleDelete"
                >Delete</el-button
            > -->
        </h5>

        <el-table v-loading="tableLoad" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column prop="_id" label="Id" width="220"></el-table-column>
            <el-table-column prop="name" label="渠道名字"></el-table-column>
            <el-table-column prop="key" label="渠道编号"></el-table-column>
            <el-table-column prop="link" label="渠道注册链接">
                <template slot-scope="scope">
                    {{ `${channelUrl}${scope.row.key}` }}
                </template>
            </el-table-column>
            <el-table-column prop="total" label="渠道注册数"></el-table-column>
            <el-table-column label="操作" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                    <el-popconfirm :title="scope.row.status ? '确定禁用该渠道吗？' : '确定开启该渠道吗？'" @confirm="() => confirm(scope.row)">
                        <el-button :disabled="scope.row.protected" type="text" size="small" slot="reference">{{ scope.row.status ? '禁用' : '开启' }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>
        <add-modal :dialogVisible="addFlag" @closeModal="closeAddModal" v-if="addFlag" />
    </div>
</template>

<script>
import serverApi from '../../server/index';
import AddModal from './add/index.vue';
import EditModal from './edit/index.vue';
export default {
    components: {
        AddModal,
        EditModal,
    },
    data() {
        return {
            sum: 0,
            form: {
                name: '',
            },
            name: '',
            searchLoad: false,
            deleteLoad: false,

            //
            tableLoad: false,
            tableData: [],
            params: {
                size: 10,
                page: 1,
            },
            total: 0,
            multipleData: [],
            channelUrl: process.env.VUE_APP_CHANNEL_URL,

            // add
            addFlag: false,
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.tableLoad = true;
                const { data } = await serverApi.channelList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.tableLoad = false;
            }
        },
        handleCurrentChange(val) {
            this.initData({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.initData(this.form);
        },

        handleSearch() {
            this.searchLoad = true;
            this.pageParams.page = 1;
            this.initData();
        },
        handleSelectionChange(val) {
            this.multipleData = val;
            console.log('multipleData: []', this.multipleData);
        },
        handleDelete() {},
        handleAdd() {
            this.addFlag = true;
        },
        closeAddModal(isUpdate) {
            this.addFlag = false;
            if (isUpdate) {
                this.initData();
            }
        },
        
        async confirm(item) {
            try {
                console.log('item', item);
                const params = {
                    id: item._id,
                    status: !item.status,
                };
                const { data } = await serverApi.channelStatus(params);
                if (data.code !== 0) throw new Error(data.error);
                this.$message({
                    message: 'Edit success',
                    type: 'success',
                });
                this.initData();
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}

h4 {
    margin-bottom: 30px;
}

h5 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.demo-input-suffix {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
</style>
